import { render, staticRenderFns } from "./debug-component.vue?vue&type=template&id=1f85a0ed&scoped=true"
import script from "./debug-component.ts?vue&type=script&lang=ts&external"
export * from "./debug-component.ts?vue&type=script&lang=ts&external"
import style0 from "./debug-component.scss?vue&type=style&index=0&id=1f85a0ed&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85a0ed",
  null
  
)

export default component.exports